import { defineStore } from "pinia";
import { ref } from "vue";

import userAccessService from "@/services/user-access.service";

export const useUserAccessesStore = defineStore("userAccesses", () => {
  // State
  const clients = ref([]);
  const permissions = ref(null);
  let inFlight = null;

  // Getters
  const getAccessibleClients = async () => {
    if (clients.value.length > 0) {
      return clients.value;
    }
    const response = await userAccessService.fetchAccessibleClients();
    clients.value = response.data || [];
    return clients.value;
  };
  const getUserPermissions = async () => {
    if (permissions.value !== null) {
      return { data: permissions.value };
    }
    if (inFlight) return inFlight;

    inFlight = userAccessService
      .fetchUserPermissions()
      .then((response) => {
        permissions.value = response.data;
        return response;
      })
      .finally(() => {
        inFlight = null;
      });

    return inFlight;
  };

  // Actions
  const resetState = () => {
    clients.value = [];
    permissions.value = null;
    inFlight = null;
  };
  const switchToClient = async (id) => {
    await userAccessService.switchToClient(id);

    if (window.location.pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  };

  return {
    // State
    clients,
    permissions,
    // Getters
    getAccessibleClients,
    getUserPermissions,
    // Actions
    resetState,
    switchToClient,
  };
});
